module.exports = "<div class=\"heading\">\n  <h1>Головна</h1>\n</div>\n<div class=\"page-content\">\n  TODO\n</div>"